var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"previewimg-bd"},[_c('div',{staticClass:"modal",on:{"click":function($event){return _vm.closePreview()}}},[_c('div',{staticClass:"image-box"},[_c('img',{staticClass:"center",attrs:{"src":_vm.imageUrl,"alt":""}})])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4554040e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview.vue
// module id = null
// module chunks = 